var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"support",attrs:{"useBanner":false}},[_c('Banner',{attrs:{"data":_vm.info.banner}}),_c('Train',{attrs:{"data":_vm.info.train}}),_c('News',{attrs:{"data":_vm.info.news}}),_c('Bottom',{attrs:{"data":_vm.info.bottom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }